import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getOrderingNoteSubjects } from 'src/api/ordering-note-subject';
import { enqueueSnackbarAction } from '../notifications/actions';
import {
    FETCH_ORDERING_NOTE_SUBJECTS,
    requestOrderingNoteSubjects,
    requestOrderingNoteSubjectsSuccess,
} from './actions';

function* fetchOrderingNoteSubjectsSaga(): SagaIterator {
    yield put(requestOrderingNoteSubjects());

    const { error, response } = yield call(getOrderingNoteSubjects);

    if (error) {
        yield put(
            enqueueSnackbarAction({
                message: `Order note subjects konnten nicht geladen werden --- ${error.message}`,
                options: { key: new Date().getTime() + Math.random(), variant: 'error' },
            })
        );
    } else {
        yield put(requestOrderingNoteSubjectsSuccess(response));
    }
}

export function* generateFetchOrderingNoteSubjectsWatcher() {
    yield takeLatest(FETCH_ORDERING_NOTE_SUBJECTS, fetchOrderingNoteSubjectsSaga);
}
